module.exports = __webpack_public_path__ + "static/media/tarjeta-15dic.c8e623a3.svg";